import React from "react";
import { GetEntryAPI, UpdateAPI } from "../services";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LanguageLoader } from '../assets/languages';
import Fields from "../components/features/Fields";
import Comment from "../components/features/Comment";
import Subpanel from "../components/features/Subpanel";
import { PanelSkeleton } from "../components/layouts/Skeleton";
import AdditionalButtons from "../components/features/AdditionalButtons";

const DetailView = () =>
{
	const settings = useSelector((state) => state.settings);
	const user = useSelector((state) => state.current_user);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const {module, id} = useParams();
	const location = useLocation();
	const subpanel = (location.pathname.indexOf('/subpanel/') !== -1 || (location.state && location.state.subpanel)) ? true : false;
	const definition = settings.definitions[subpanel ? 'subpanels' : 'modules'][module];
	const fields = definition.fields;
	const subpanels = settings.subpanels[module];
	const [dataEntry, SetDataEntry] = useState({});
	const [loading, SetLoading] = useState(true);
	const navigate = useNavigate();
	
	useEffect(() =>
	{
		window.scrollTo(0, 0);
		SetLoading(true);
		GetEntry();
	// eslint-disable-next-line
	}, [module, id]);

	const GetEntry = async () =>
	{
		try
		{
			if (id && fields)
			{
				var selectedFields = ['id'];
				for(let field in fields)
				{
					selectedFields.push(field);
					if(fields[field]['related_to'] && fields[field]['related_to'] !== '')
					{
						selectedFields.push(fields[field]['related_to']);
					}
				}
				const data = { id: id, module: module, selected_fields: selectedFields }
				const APIResponse = await GetEntryAPI(data);
				if (APIResponse)
				{
					SetDataEntry(APIResponse[0]);
					SetLoading(false);
				}
			}
			else
			{
				SetDataEntry({});
				SetLoading(false);
			}
		}
		catch (ex){}
	}

	const HandleApproval = async (actionType) =>
	{
		const module_name = 'Approval';
		let data = {};
		if(actionType === 'accept')
		{
			data = {status : 'Approved'}
		}
		else if(actionType === 'reject')
		{
			data = {status : 'Rejected'}
		}
		else
		{
			return true;
		}
		const APIResponse = await UpdateAPI(data, module_name, dataEntry.approval.id);
		if(APIResponse.id)
		{
			SetDataEntry((prevData) => ({
				...prevData,
				approval: {
				  ...prevData.approval,
				  status: actionType === 'accept' ? language.APPROVED : language.REJECTED,
				  status_key: actionType,
				},
			  }));
		}
	}

	if(!definition.access.view)
	{
		return <div className='wrapper flex flex-wrap justify-between items-center'>
			<div>{language.ERROR.NON_ACCESSIBLE}</div>
			<Link to='/' className="btn -mt-1">بازگشت به صفحه اصلی</Link>
		</div>;
	}
	return (
		<>
		{ user.is_partner !== 1 && user.is_partner !== '1' && dataEntry.approval ?
			<div className='wrapper'>
				<div className="flex flex-wrap">
					<div className="Field_Container mb-0">
						<div className="flex">
							<label>{language.APPROVAL_STATUS}</label>
						</div>
						<div className="value">{dataEntry.approval.status}</div>
					</div>
					{dataEntry.approval.status_key === 'Pending' ?
					<div className="Field_Container mb-0 text-end">
						<button onClick={() => HandleApproval('accept')} className='btn btn-secondary mb-2'>{language.APPROVE}</button>
						<button onClick={() => HandleApproval('reject')} className='btn bg-transparent border-danger text-danger mb-2'>{language.DECLINE}</button>
					</div>
					: null }
				</div>
			</div>
		: null }
		{loading ? <PanelSkeleton/> :
		<div className='wrapper'>
			<div className='title flex justify-between w-full'>
				<h6>{language["DETAIL_VIEW"] + ' ' + definition.label[preferences.language]}</h6>
				<div className="flex">
					<AdditionalButtons module={module} id={id}/>
					<Link onClick={() => navigate(-1)} className='btn btn-secondary mb-2'>{language.AUTHENTICATION.RETURN}</Link>
					{definition.access.edit ? <button onClick={() => navigate('/edit/'+definition.module+'/'+id, {state:{'subpanel': subpanel}})} className='btn-primary mb-2'>{language["EDIT"]}</button> : null}
				</div>
			</div>
			<div className="flex flex-wrap">
				{Object.keys(fields).map((field, index) =>
				{
					if(settings.hidden_fields.includes(field))
					{
						return null;
					}
					return <Fields key={index}
						subpanel={subpanel}
						module={module}
						field={field}
						value={dataEntry[field]}
						editable={false}
						related_to={fields[field]['related_to'] ? dataEntry[fields[field]['related_to']] : null}
					/>
				})}
			</div>
		</div>
		}
		{definition.comment ? <Comment editor={true} /> : null}
		{subpanels && Object.entries(subpanels).map((item, index) => item[1] ? <Subpanel key={index} data={item}/> : null )}
		</>
	);
}

export default DetailView;